import {defineStore} from "pinia";

export const appOptionsStore = defineStore('appOptions', {
  state: () => ({
    flag: false,
    snack: null,
    type: null,
    title: null,
    loginError: null,
    loading:false,
    loadingText:null,
    globalSnack:false,
    globalSnackText:null,
    globalSnackColor:null,
    globalSnackColorButton:null,
    globalSnackTitleText:null
  }),
  getters:{
    getFlag: (state) => state.flag,
    getSnack: (state) => state.snack,
    getType: (state) => state.type,
    getTitle: (state) => state.title,
    getLoginError: (state) => state.loginError,
    getLoading: (state) => state.loading,
    getLoadingText: (state) => state.loadingText
  },
  actions:{
    setFlag(payload){
      this.flag = payload;
    },
    setLoginError(payload){
      this.loginError = payload;
    },
    setAlert({flag, title, snack, type}){
      this.type = type;
      this.title = title;
      this.snack = snack;
      this.flag = flag;
    },
    setLoading(loading, text=null){
      this.loadingText = text;
      this.loading = loading;
    },
    setGlobalSnack(close, text, color, btnColor, titleText=""){
      this.globalSnack = close;
      this.globalSnackText = text;
      this.globalSnackColor = color;
      this.globalSnackColorButton = btnColor;
      this.globalSnackTitleText = titleText;
    }
  }
});
